import type { AddonFilter, EventData } from '../types.tsx';
import { withConnectHost } from './ecosystem-connect-host.tsx';

const broadcastConnectEvent = (
	eventName: string,
	addonFilter: AddonFilter,
	eventData?: EventData,
) => {
	withConnectHost((host) => {
		host && host.broadcastEvent(eventName, addonFilter, eventData);
	});
};

export default broadcastConnectEvent;
